import { useCallback, useMemo } from 'react'
import { Formik, Form } from 'formik'
import { string, object, SchemaOf } from 'yup'

import { FormTextField } from '@collaborate-health/forms'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@collaborate-health/uikit'
import { maxLength, noWhitespaces, requiredField } from '@tabeeb/shared/utils/validationErrorMessages'
import { UpdateQualificationRequest } from '@tabeeb/contracts/microservices/swagger-certificate-service'

const validationSchema: SchemaOf<Pick<UpdateQualificationRequest, 'Name'>> = object().shape({
  Name: string().strict().trim(noWhitespaces).required(requiredField).max(256, maxLength(256)),
})

export interface RenameQualificationDialogProps {
  open: boolean
  initial: string
  onClose: () => void
  onSubmit: (newName: string) => void
}

const RenameQualificationDialog: React.FC<RenameQualificationDialogProps> = ({ open, initial, onClose, onSubmit }) => {
  const initialValues = useMemo<Pick<UpdateQualificationRequest, 'Name'>>(
    () => ({
      Name: initial,
    }),
    [initial]
  )

  const handleSubmit = useCallback(
    (values: Pick<UpdateQualificationRequest, 'Name'>) => {
      onSubmit(values.Name)
      onClose()
    },
    [onSubmit, onClose]
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid, dirty }) => (
          <Form>
            <DialogTitle>Rename Qualification</DialogTitle>
            <DialogContent>
              <FormTextField name='Name' label='Name' fullWidth autoFocus />
            </DialogContent>
            <DialogActions>
              <Button color='primary' onClick={onClose}>
                Cancel
              </Button>
              <Button type='submit' variant='contained' color='primary' disabled={!isValid || !dirty}>
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default RenameQualificationDialog

